import React from "react"
import DateHelper from '../../DateHelper/DateHelper';
import { format} from 'date-fns';


class StartEndTimeDataType extends React.Component{
  constructor(props) {
    super(props);
  };

  render() {
    return(
      <div>
        {
          this.props.row.scheduled_start_time || this.props.row.scheduled_end_time
          ?
          <p>{this.props.row.scheduled_start_time ? DateHelper.printDateToScreen(new Date(this.props.row.scheduled_start_time), this.props.time_format, true) : I18n.t('na')} - {this.props.row.scheduled_end_time ? DateHelper.printDateToScreen(new Date(this.props.row.scheduled_end_time), this.props.time_format, true) : I18n.t('na')}</p>
          :
          <span className="none">{I18n.t('none')}</span>
        }
      </div>
    );
  };

};

export default StartEndTimeDataType